import { combineReducers } from 'redux';

import payrollReducer from './payrollReducer';
import partnerReducer from './partnerReducer';
import dateReducer from './dateReducer';

const rootReducer = combineReducers({
    payrollState: payrollReducer,
    partnerState: partnerReducer,
    dateState: dateReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/reducers/index.js